import PropTypes from 'prop-types';

export const conditionShape = {
  field: PropTypes.string,
  operator: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
};
